import styles from "../../styles/modal.module.css";
import commonStyles from "../../styles/common.module.css";
import { useTranslation } from "react-i18next";
import { SUPPORT_EMAIL, SUPPORT_PHONE } from "../../config";
interface IProps {
  onClose: () => void;
  actions: {
    continue: () => void;
    isAccepted?: boolean;
  };
}

const PrivacyPolicyModal = ({ onClose, actions }: IProps) => {
  const { t } = useTranslation();
  return (
    <div className={styles.privacyModalContent}>
      <div className={styles.modalHeader}>
        <div onClick={onClose} title="Close">
          <img src="/assets/cross.png" className={styles.crossWrap} />
        </div>
        <div className={styles.privacyModalTitle}>{t('privacymodal.title')}</div>
      </div>
      <div className={styles.privacyModalBody}>
        <div className={styles.privacyPolicyContent}>
          <p>
            {t('privacymodal.purpose.header')}
          </p>
          <ul>
            <li>{t('privacymodal.purpose1')}</li>
            <li>{t('privacymodal.purpose2')}</li>
            <li>{t('privacymodal.purpose3')}</li>
            <li>{t('privacymodal.purpose4')}</li>
          </ul>
          <p>
            {t('privacymodal.description.collection')}
          </p>
          <p>{t('privacymodal.description.consent')}</p>
          <p>{t('privacymodal.description.withdrawconsent')}</p>
          <p>
            {t('privacymodal.description.contact.intro')}{" "}
            <a href={`mailto:${SUPPORT_EMAIL}`} className={commonStyles.link}>
              {SUPPORT_EMAIL}
            </a>
            {SUPPORT_PHONE && (
              <>
                {" "}
                {t('privacymodal.description.contact.phone')}{" "}
                <a href={`tel:${SUPPORT_PHONE.replace(/[^+\d]/g, "")}`} className={commonStyles.link}>
                  {SUPPORT_PHONE}
                </a>
              </>
            )}
          </p>
        </div>
        <div className={styles.modalFooter}>
          {!actions.isAccepted && (
            <button
              onClick={actions.continue}
              className={commonStyles.button_secondary}
              style={{
                fontSize: "20px",
              }}
            >
              {t('button.accept')}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicyModal;
